export default "__VITE_ASSET__BvnfDoiJ__"